export const loginUrl = "https://app.paydeck.in/user/login";
export const registerUrl = "https://app.paydeck.in/user/login/new";

export const navItems = [
	{ label: "What you can pay", href: "/#payments" },
	{ label: "How it works", href: "/#how-it-works" },
	{ label: "Why Paydeck", href: "/#why-paydeck" },
	{ label: "Our story", href: "/#our-story" }
];

export const companyLinks = [
	{ label: "About Us", href: "/about-us" },
	{ label: "Terms of Service", href: "/terms-of-service" },
	{ label: "Privacy", href: "/privacy-policy" },
	{ label: "Contact Us", href: "/help-center" }
];

export const resourceLinks = [
	{ label: "Payment Types", href: "/payment-types" },
	{ label: "How Paydeck Works", href: "/how-it-works" },
	{ label: "FAQs", href: "/frequently-asked-questions" },
	{ label: "Refund Policy", href: "/refund-policy" },
	{ label: "Fraud Reporting & Management", href: "/settlement-guide" }
];

export const publicLinks = [
	...companyLinks.map((link) => ({ ...link, group: "Company" })),
	...resourceLinks.map((link) => ({ ...link, group: "Resources" }))
];
